export const MAX_INTENTION_LENGTH = 160

export enum IntentionActionTypes {
  ADD_PRAYER = 'ADD_PRAYER',
  SET_WIDGET_INTENTION = 'SET_WIDGET_INTENTION',
}
